/* © 2023 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import { styled } from '@mui/system'
import { Layout } from '../components'
import {
  PROMETHEAN_NEUTRAL_DARK_GREY,
  PROMETHEAN_TYPOGRAPHY_BODY,
  PROMETHEAN_NEUTRAL_WHITE,
  PROMETHEAN_TEXT,
} from '@prom/web-embers'

export const StyledEmailLoginPage = styled(Layout)({
  '.EmailLogin': {
    '&-thirdPartyButtons': {
      marginBottom: 42,
    },
    '&-dividerText': {
      position: 'relative',
      height: 24,
      margin: '24px 0 33px',
      i: {
        display: 'block',
        position: 'absolute',
        width: '100%',
        height: '1px',
        top: 11,
        left: 0,
        backgroundColor: PROMETHEAN_NEUTRAL_DARK_GREY,
      },
      span: {
        ...PROMETHEAN_TYPOGRAPHY_BODY,
        position: 'absolute',
        padding: '0 8px',
        left: '50%',
        top: '50%',
        transform: 'translate(-50%, -50%)',
        backgroundColor: PROMETHEAN_NEUTRAL_WHITE,
      },
    },
    '&-createAccountLink-imported': {
      marginTop: 33,
    },
  },
  '.EmbersInput-root.Layout-formItem .MuiInputLabel-root': {
    color: `${PROMETHEAN_TEXT} !important`,
  },
})
